// ============================================================
// 教练密码列表
// ------------------------------------------------------------
// 这是「客户端密码门」，本质是 UX 上挡住非授权用户，
// 不是真正的安全防护（前端代码任何人都能看到 hash）。
// 但对 < 10 人的小范围试用 + 教练群体来说，足够「防君子不防小人」。
//
// 添加 / 撤销密码：
//   1. 在浏览器控制台或在线工具计算密码的 hash：
//        await crypto.subtle.digest('SHA-256', new TextEncoder().encode('你的密码'))
//          .then(b => Array.from(new Uint8Array(b))
//            .map(x => x.toString(16).padStart(2,'0')).join(''))
//      或者本文件底部有个工具函数 hashForDev(pwd)，本地打开 console 调它即可
//   2. 把得到的 hash 放进 PASSWORDS 数组里，加一个 label 标识谁在用
//   3. 重新 npm run build → 部署
//   4. 要"撤销"某个教练的密码：直接删掉那一行就行
//
// label 字段会写进 localStorage，将来可在抽屉里看到「当前教练: Xxx」
// ============================================================

// SHA-256 hex 字符串（小写）
//
// ⚠️ 初次部署前，必须用以下任一方式生成 hash 后填到这里：
//   方式 1（推荐）：在密码门页面输错密码 3 次后，会出现 [开发者工具]
//                  按钮，里面有一个密码 → hash 的小工具
//   方式 2：dev 模式下浏览器 console 调用 window.__hashCoachPwd('你的密码')
//   方式 3：在线工具如 https://emn178.github.io/online-tools/sha256.html
//
// 推荐每个教练给一个独立密码 + label，将来谁出问题直接删 hash 即可。
//
// 留空 hash 的行不会启用；先建好 9 个 slot 备用。
export const PASSWORDS = [
  { label: 'LNGtest', hash: '5c976b2dd16cab7363e32dc0ee0a3577ee0b36e1deca49094bd1a1682730310a' },
  { label: 'Coach B', hash: '' },
  { label: 'Coach C', hash: '' },
  { label: 'Coach D', hash: '' },
  { label: 'Coach E', hash: '' },
  { label: 'Coach F', hash: '' },
  { label: 'Coach G', hash: '' },
  { label: 'Coach H', hash: '' },
  { label: 'Coach I', hash: '' },
];

// 应急后门：所有 hash 都为空时（首次部署还没配置），临时开放访问
// 部署后请务必填一个真正的密码 hash，否则等于没有密码门
export const isGateDisabledAccidentally = () =>
  PASSWORDS.every((p) => !p.hash);

// 计算密码 hash：Web Crypto API，返回 hex 字符串
export async function sha256Hex(input) {
  const buf = new TextEncoder().encode(input);
  const hashBuf = await crypto.subtle.digest('SHA-256', buf);
  return Array.from(new Uint8Array(hashBuf))
    .map((x) => x.toString(16).padStart(2, '0'))
    .join('');
}

// 校验密码是否在 PASSWORDS 表里。命中则返回 { label }；否则 null
export async function verifyPassword(pwd) {
  if (!pwd) return null;
  const h = await sha256Hex(pwd.trim());
  const found = PASSWORDS.find((p) => p.hash && p.hash.toLowerCase() === h);
  return found ? { label: found.label } : null;
}

// 开发时用：在浏览器 console 调用 window.__hashCoachPwd('你的密码')
// 然后复制控制台输出，粘到 PASSWORDS 里
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-underscore-dangle
  window.__hashCoachPwd = async (pwd) => {
    const h = await sha256Hex(pwd);
    // eslint-disable-next-line no-console
    console.log(`[coachPwd] '${pwd}' → ${h}`);
    return h;
  };
}
